import * as React from 'react';
import axios from 'axios';
import {getHeadersToken, getUserId} from './MonCompteAction';
import { RenderPointRelai } from './RenderPointRelai';
import { LeafletMap } from '../leaflet/LeafletMap';
import Icons from './Icons';
import {getHostApi, supportPolymer} from '../../utils';

interface RenderPointsRelaisState {
  shippingPoints: any[];
  address: string;
  maxRadius: number;
  gpsCoordinates: any;
}

interface RenderPointsRelaisProps {
  orderId: any;
  retourId?: any;
  defaultAddress?: string;
  showButtons: boolean;

  onPrClick?(shippingPoint: any): void;
}

export class RenderPointsRelais extends React.Component<RenderPointsRelaisProps, RenderPointsRelaisState> {

  constructor(props: RenderPointsRelaisProps) {
    super(props);

    this.state = {
      shippingPoints: [],
      address: props.defaultAddress as string,
      maxRadius: 20,
      gpsCoordinates: {},
    };
  }

  componentWillMount() {
    this._getShippingPoints();

    this._loader('masquer');
  }

  _getShippingPoints = () => {
    let url = null;

    if (this.props.retourId && this.props.orderId) {
      url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.orderId}/reclamations/${this.props.retourId}/shipping-points`;
    } else if (this.props.orderId) {
      url = `${getHostApi()}/orders/${this.props.orderId}/shipping-points`;
    }

    axios.get(url as string, {
      headers: getHeadersToken(),
      withCredentials: true,
      params: {
        address: this.state.address,
        maxRadius: this.state.maxRadius,
      },
    }).then((res) => {
      this.setState({
        gpsCoordinates: res.data.GPSCoordinates,
        shippingPoints: res.data.shipping_points,
      });
      this._loader('masquer');
    }).catch((err) => {
      console.log(err);
      this._loader('masquer');
    });
  }

  _onSearchClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    this._loader('afficher');
    this._getShippingPoints();
  }

  _resetAddress = () => {
    this.setState({ address: '' });
  }

  _loader = (state: string) => {
    const miniLoader = document.querySelectorAll('.miniLoader');
    [].forEach.call(miniLoader, function (item: any) {
      if (state == 'masquer') {
        item.classList.add('d-none');
      } else if (state == 'afficher') {
        item.classList.remove('d-none');
      }
    });
  }

  _onUpdateInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      address: event.target.value,
    });
  }

  _onUpdateRadius = (event: React.ChangeEvent<HTMLInputElement>) => {
    this._loader('afficher');
    this.setState({
      maxRadius: parseInt(event.target.value),
    });
  }

  _onPrClick = (event: React.MouseEvent<HTMLButtonElement> | null, shippingPoint: any) => {
    if (this.props.onPrClick) {
      this.props.onPrClick(shippingPoint);
    }
  }

  _onPrHover = (event: React.MouseEvent<HTMLDivElement>, shippingPoint: any, index: number) => {
    const div = document.getElementById(shippingPoint.id + '-' + index);
    const divs = document.getElementsByClassName('pointRelais');

    if(!div) return;

    for (let i = 0 ; i < divs.length ; i++) {
      divs[i].setAttribute('style', 'background: none');
    }

    div.style.background = '#eee';
  }

  render() {
    const renderInput = () => {
      return (
        <div>
          <div className="d-flex position-relative">
            <div style={{ width: '90%' }} className="position-relative">
              <input type="text" value={this.state.address} onChange={this._onUpdateInput}
                     className="mt-0 py-1 pl-2 pr-5 w-100" style={{ height: '38px' }}/>
              <button onClick={this._resetAddress} className="position-absolute border-0 cursor-pointer"
                      style={{ top: '0', right: '0', height: '38px', width: '38px', background: 'none' }}>
                <Icons icon="close" size={30} color="black" className="pt-1 pl-1"/>
              </button>
            </div>
            <button onClick={this._onSearchClick}
                    style={{ width: '10%', height: '38px', borderRadius: '0 50px 50px 0' }}
                    className=" bg-blue white border-0 cursor-pointer">
              <Icons icon="search" size={30} color="white"/>
            </button>
          </div>
          <div className="mt-2 font14">A <span>{this.state.maxRadius} Km autour de moi</span></div>
          <input type="range" max={100} min={1} value={this.state.maxRadius} id="range"
                 className="w-100 mb-3 cursor-pointer rangeRadiusPr" onChange={this._onUpdateRadius}
                 onMouseUp={this._getShippingPoints}/>
        </div>
      );
    };

    const renderSelectButton = (shippingPoint: any) => {
      if (this.props.showButtons) {
        return (
          <div className="col-lg-3 col-md-3 col-12 text-right p-0">
            <button className="bg-blue white px-3 py-2 border-0 font12 cursor-pointer w-100"
                    onClick={e => this._onPrClick(e, shippingPoint)}>Sélectionner
            </button>
          </div>
        );
      }
    };

    const listShippingPoints = this.state.shippingPoints.map((shippingPoint, index: number) => {
      return (
        <div onClick={e => this._onPrHover(e, shippingPoint, index)} className="d-flex pointRelais py-2"
             id={shippingPoint.id + '-' + index} key={shippingPoint.id}>
          <RenderPointRelai shippingPoint={shippingPoint}/>
          {renderSelectButton(shippingPoint)}
        </div>
      );
    });

    const renderPointsRelais = () => {
      if (listShippingPoints.length > 0) {
        return (
          <div>
            <p className="font12">{listShippingPoints.length} résultat(s) trouvé(s)</p>
            {listShippingPoints}
          </div>
        );
      }
      return (
        <div>
          <p className="text-center font14 m-0">Aucun résultat trouvé à {this.state.maxRadius}Km autour de vous.</p>
        </div>
      );
    };

    return (
      <div className="position-relative">
        <div id="miniLoader" className="miniLoader">
              <span className="loader loader-quart-8">
                <img src="/order/images/ic_compte.svg"/>
              </span>
          <div className="textLoader">Chargement ...</div>
        </div>
        {renderInput()}
        {supportPolymer() &&
        <div className="w-100 border" style={{ height: '242px' }}>
          <LeafletMap shippingPoints={this.state.shippingPoints} onPrClick={e => this._onPrClick(null, e)}
                      gpsCoordinates={this.state.gpsCoordinates}/>
        </div>
        }
        <div style={{ maxHeight: '240px', overflow: 'auto' }} className="mt-3">
          {renderPointsRelais()}
        </div>
      </div>
    );
  }
}
